// Login/registro contra el backend ecommercejwt. El JWT se guarda en
// localStorage junto con los datos básicos del usuario, y se manda como
// query param `?token=...` (no como header `Authorization: Bearer`) --
// el propio JwtHandler del backend soporta ese fallback explícitamente,
// pensado para hostings que no siempre pasan bien el header. Usarlo como
// query param evita depender de que nuestro proxy reenvíe headers
// correctamente, mismo criterio que ya usamos para invitado_token.
import { request } from './ecommerceClient';

const JWT_STORAGE_KEY = 'miestampita_jwt';
const USER_STORAGE_KEY = 'miestampita_usuario';

const persistAuth = ({ token, usuario }) => {
  try {
    localStorage.setItem(JWT_STORAGE_KEY, token);
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(usuario));
  } catch {
    // localStorage puede no estar disponible (ej. modo privado); la sesión
    // simplemente no persiste entre recargas.
  }
};

export const getStoredAuth = () => {
  try {
    const token = localStorage.getItem(JWT_STORAGE_KEY);
    const usuarioRaw = localStorage.getItem(USER_STORAGE_KEY);
    if (!token || !usuarioRaw) return { token: null, usuario: null };
    return { token, usuario: JSON.parse(usuarioRaw) };
  } catch {
    return { token: null, usuario: null };
  }
};

export const register = async ({ nombre, email, password }) => {
  const data = await request('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ nombre, email, password }),
  });
  persistAuth(data);
  return data;
};

export const login = async ({ email, password }) => {
  const data = await request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  persistAuth(data);
  return data;
};

export const logout = () => {
  try {
    localStorage.removeItem(JWT_STORAGE_KEY);
    localStorage.removeItem(USER_STORAGE_KEY);
  } catch {
    // Nada que limpiar si localStorage no está disponible.
  }
};
